'use client'

import { PersonalizationCrossSelling } from 'cross-selling/components/client/PersonalizationCrossSelling/PersonalizationCrossSelling'
import { useLastViewed } from 'cross-selling/contexts/LastViewedProvider/LastViewedProvider'
import type { CrossSellingPersonalizationServiceResponse } from 'cross-selling/services/getPersonalization/getPersonalization'
import type { CrossSellingServiceResponse } from 'cross-selling/types'
import type { ImagesSizes } from 'product-card/context/ProductCardImagesSizesContext/ProductCardImagesSizesContext'
import { ProductLocations } from 'product/types/ProductLocations'

import { dataTestIds } from '../../../constants/dataTestIds/dataTestIds'

interface PersonalizationWrapperProps {
	personalizedProducts: CrossSellingPersonalizationServiceResponse[]
	productCardImagesSizes: ImagesSizes[]
	similarProducts: CrossSellingServiceResponse[]
	title: string
	totalLookProducts: CrossSellingServiceResponse[]
}

export function PersonalizationWrapper({
	personalizedProducts,
	productCardImagesSizes,
	similarProducts,
	title,
	totalLookProducts,
}: PersonalizationWrapperProps): React.ReactNode {
	const { lastViewedProducts } = useLastViewed()

	if (!lastViewedProducts) {
		return null
	}

	const excludedProducts = [
		...similarProducts,
		...totalLookProducts,
		...lastViewedProducts,
	]

	return (
		<PersonalizationCrossSelling
			title={title}
			excludedProducts={excludedProducts}
			personalizedProducts={personalizedProducts}
			productCardImagesSizes={productCardImagesSizes}
			location={ProductLocations.CrossSellingPersonalization}
			dataTestId={dataTestIds['pdp.crossSelling.recommendations']}
		/>
	)
}
